<template>
    <div
        class="flex cursor-pointer items-center gap-4 border p-4 hover:border-primary-500"
        :class="selected ? 'border-primary-800' : ''"
        :style="[
            selected
                ? 'box-shadow: 0 0 0 1px rgb(var(--color-primary-500));'
                : ''
        ]"
        @click="$emit('select')"
    >
        <radio-button
            :model-value="selected ? sessionData.id : null"
            :input-id="sessionData.id"
            name="session"
            :value="sessionData.id"
            @update:model-value="$event ? $emit('select') : void 0"
        />

        <div class="flex-1 space-y-1">
            <div class="flex gap-4">
                <div class="flex-1">
                    <div class="text-lg font-semibold">
                        {{ sessionDate }}
                    </div>

                    <div
                        v-if="sessionTitle !== ''"
                        class="pb-2 text-sm"
                    >
                        {{ sessionTitle }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { graphql } from '~/resources/graphql'

export const SessionDisplaySessionFragment = graphql(`
    fragment SessionDisplaySessionFragment on Session {
        id
        subtitle
        startDateLocal
        endDateLocal
    }
`)
</script>

<script setup lang="ts">
import RadioButton from 'primevue/radiobutton'
import { computed } from 'vue'
import type { FragmentType } from '~/resources/graphql'
import { getFragmentData } from '~/resources/graphql'
import { formatRange, parseLocal } from '~/composables/support/localization'

const props = defineProps<{
    session: FragmentType<typeof SessionDisplaySessionFragment>
    selected: boolean
}>()

defineEmits<{
    (e: 'select'): void
}>()

const sessionData = computed(() =>
    getFragmentData(SessionDisplaySessionFragment, props.session)
)

const sessionTitle = computed(() => {
    return sessionData.value.subtitle
})

const sessionDate = computed(() =>
    formatRange(
        parseLocal(sessionData.value.startDateLocal),
        parseLocal(sessionData.value.endDateLocal)
    )
)
</script>
